import { render } from "./typeIndivid.vue?vue&type=template&id=6e2d7382&scoped=true"
import script from "./typeIndivid.vue?vue&type=script&lang=js"
export * from "./typeIndivid.vue?vue&type=script&lang=js"

import "./typeIndivid.vue?vue&type=style&index=0&id=6e2d7382&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2d7382"]])

export default __exports__